import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import * as notify from "../../notify";
import "../../stylesheets/Modal.css";

const Reason = (props) => {
  const [reason, setReason] = useState("");
  const [submitFailed, setSubmitFailed] = useState(false);

  useEffect(() => {
    if (!props.show) {
      setReason("");
      setSubmitFailed(false);
    }
  }, [props.show]);

  const handleChange = (e) => {
    setReason(e.target.value);
    if (submitFailed && e.target.value.trim()) {
      setSubmitFailed(false);
    }
  };

  const handleSubmit = () => {
    if (!reason.trim()) {
      notify.error("Please enter a reason");
      setSubmitFailed(true);
      return;
    }

    props.onConfirm(reason.trim());
    setSubmitFailed(false);
    setReason("");
  };

  const handleCancel = () => {
    setSubmitFailed(false);
    props.onCancel();
    setReason("");
  };

  return (
    <Modal
      isOpen={props.show}
      shouldCloseOnOverlayClick={true}
      onRequestClose={handleCancel}
      className="Modal deny denyreason"
      overlayClassName="Overlay deny"
      ariaHideApp={false}
      style={{ width: "425px" }}
    >
      <h3>
        {props.title || "Reason"}
        <span style={{ color: "red" }}>*</span>
      </h3>
      <textarea
        className="proview-input details"
        placeholder={props.placeholder || "Please enter your reason..."}
        value={reason}
        onChange={handleChange}
        style={{
          border:
            submitFailed && !reason.trim()
              ? "1px solid #cc0000"
              : "1px solid #c9c9c9",
        }}
        autoFocus
      />
      {props.message ? (
        <h4 style={{ fontWeight: "bold" }}>{props.message}</h4>
      ) : null}
      <div>
        <button className="proview-button cancel left" onClick={handleCancel}>
          Cancel
        </button>
        <button className="proview-button right" onClick={handleSubmit}>
          {props.submitLabel || "Submit"}
        </button>
      </div>
    </Modal>
  );
};

export default Reason;
